import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataTutorial(params) {
	return client.get("api/tutorial/data", {
		params: params,
	});
}

function getDataTutorialActive(params) {
	return client.get("api/tutorial/data-active", {
		params: params,
	});
}

function addTutorial(params) {
	return client.post("api/tutorial/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateTutorial(params) {
	return client.post("api/tutorial/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteTutorial(params) {
	return client.post("api/tutorial/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusTutorial(params) {
	return client.post("api/tutorial/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post('api/tutorial/image', params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}


export default {
	getDataTutorial,
	getDataTutorialActive,
	addTutorial,
	updateTutorial,
	deleteTutorial,
	statusTutorial,
	uploadImage,
};